import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import StatsOverviewCard from '../../components/cards/StatsOverviewCard';
import SyncCard from '../../components/cards/SyncCard';
import FormCard from '../../components/cards/FormCard';
import { CompletedFormIcon, PendingFormIcon } from '../../components/Icons/svgIcons';
import { useProjectsPage } from '../../hooks/useProjectsPage'; 
import MainPageLayout from '../../components/layout/MainPageLayout';
import FormListPageSkeleton from '../../components/skeletons/FormListPageSkeleton';
import { FormsTour } from '../../components/ui/tour/FormsTour';

const FormsPage = () => {
  const {
    navigate,
    pendingCount,
    isDataReady,
    allFormsSorted,
    handleFillForm,
    handleSyncNow
  } = useProjectsPage();

  const { forms } = useSelector(state => state.forms);

  const submittedCount = useMemo(() => {
    if (!forms || forms.length === 0) return 0;
    return forms.filter(form => 
      form.submissions_exists === true || 
      form.submissions_exists === "true" || 
      form.submissions_exists === 1
    ).length;
  }, [forms]);

  const allFormsCount = forms?.length || 0;

  if (!isDataReady) {
      return (
        <MainPageLayout>
            <FormListPageSkeleton showFullPage={true} />
        </MainPageLayout>
      );
  }

  return (
    <MainPageLayout>
      <div className="space-y-6">
        <div className="grid grid-cols-2 gap-3">
          <div id="tour-forms-submitted-card" className="h-full">
            <StatsOverviewCard
              title="Submitted"
              count={submittedCount}
              icon={<CompletedFormIcon />}
              onViewAll={() => navigate('/forms/completed')}
              buttonColor="secondary"
            />
          </div>
          
          <div id="tour-forms-all-card" className="h-full">
            <StatsOverviewCard
              title="All Forms"
              count={allFormsCount}
              icon={<PendingFormIcon />}
              onViewAll={() => navigate('/forms/all')}
              buttonColor="secondary"
            />
          </div>
          
          <div id="tour-forms-sync-card" className="col-span-2">
            <SyncCard
              title="Form's Sync Status"
              count={pendingCount}
              onSyncNow={handleSyncNow}
              onViewForms={() => navigate('/sync')}
            />
          </div>
        </div>

        <div id="tour-forms-list">
          <div className="flex justify-between items-center mb-4 px-1">
            <h2 className="text-gray-900 font-bold text-lg">All Forms</h2>
            {allFormsCount > 3 && (
              <button 
                onClick={() => navigate('/forms/all')} 
                className="text-[var(--btn-primary-bg)] text-xs font-bold px-3 py-1.5 border border-[var(--btn-primary-bg)] rounded-lg hover:bg-[var(--btn-primary-bg)]/5 active:scale-95 transition-all"
              >
                View All
              </button>
            )}
          </div>

          {allFormsSorted.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-900 font-bold text-lg mb-2">No Forms Assigned</p>
              <p className="text-gray-600 text-sm">You don't have any forms assigned yet. Pull down to refresh.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-4">
              {allFormsSorted.slice(0, 3).map(sortedForm => {
                const hasSubmissions = 
                  sortedForm.submissions_exists === true || 
                  sortedForm.submissions_exists === "true" || 
                  sortedForm.submissions_exists === 1;

                return (
                  <FormCard 
                    key={sortedForm.id} 
                    title={sortedForm.title || sortedForm.name} 
                    projectId={sortedForm.project_id}
                    projectName={sortedForm.project?.name}
                    description={sortedForm.description} 
                    status={sortedForm.status} 
                    submissionsExists={sortedForm.submissions_exists}
                    page="forms" 
                    onAction={() => handleFillForm(sortedForm.id)} 
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
      <FormsTour />
    </MainPageLayout>
  );
};

export default FormsPage;